module.exports = __webpack_public_path__ + "img/album14_40.700b36ca.jpg";